import { createContext, useContext, useEffect, useRef } from 'react';

/** What one field did when asked to fill its other language. */
export type FillOutcome = 'filled' | 'skipped' | 'failed';
export type Filler = () => Promise<FillOutcome>;

export interface Registry {
  add: (fill: Filler) => () => void;
  all: () => Filler[];
}

/** Set by TranslateAllProvider; bilingual fields outside one register nowhere. */
export const TranslateAllContext = createContext<Registry | null>(null);

/** A bilingual field says how it fills its other side; the latest version is used. */
export function useTranslateAllFiller(fill: Filler) {
  const registry = useContext(TranslateAllContext);
  const latest = useRef(fill);
  latest.current = fill;
  useEffect(() => registry?.add(() => latest.current()), [registry]);
}
